












import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  CoinflowIFrameProps,
  CoinflowUtils,
  handleIFrameMessage,
  IFrameMessageHandlers,
} from './lib/common';

@Component
export default class CoinflowIFrame extends Vue {
  @Prop({ required: true, type: Object }) args!: CoinflowIFrameProps &
    IFrameMessageHandlers;

  get url() {
    return CoinflowUtils.getCoinflowUrl(this.args);
  }

  sendMessage(message: string) {
    const ref = this.$refs.iframeRef as HTMLIFrameElement | null;
    if (!ref?.contentWindow) throw new Error('Iframe not defined');
    ref.contentWindow.postMessage(message, '*');
  }

  handleIframeMessages({ data, origin }: { data: string; origin: string }) {
    if (!origin.includes(CoinflowUtils.getCoinflowBaseUrl(this.args.env)))
      return;

    const promise = handleIFrameMessage(data, this.args);
    if (!promise) return;
    promise.then(this.sendMessage).catch(e => {
      console.error(e);
      this.sendMessage('ERROR ' + e.message);
    });
  }

  async listenForMessage(
    isResponseValid: (response: string) => boolean,
  ): Promise<string> {
    let handler: ({ data, origin }: { data: string; origin: string }) => void;
    return new Promise<string>((resolve, reject) => {
      handler = ({ data, origin }: { data: string; origin: string }) => {
        if (!origin.includes(CoinflowUtils.getCoinflowBaseUrl(this.args.env)))
          return;

        if (data.startsWith('ERROR')) {
          reject(new Error(data.replace('ERROR', '')));
          return;
        }

        if (!isResponseValid(data)) return;
        resolve(data);
      };

      if (!window) throw new Error('Window not defined');
      window.addEventListener('message', handler);
    }).finally(() => {
      window.removeEventListener('message', handler);
    });
  }

  async sendAndReceiveMessage(
    message: string,
    isResponseValid: (response: string) => boolean,
  ): Promise<string> {
    this.sendMessage(message);
    return this.listenForMessage(isResponseValid);
  }

  mounted() {
    if (!window) throw new Error('Window not defined');
    window.addEventListener('message', this.handleIframeMessages);
  }

  beforeDestroy() {
    window.removeEventListener('message', this.handleIframeMessages);
  }
}
